import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let blank = {
    component: {
        render(c) {
            return c("router-view");
        },
    },
};

function configRoutes() {
    return [
        {
            path: "/",
            redirect: "/order",
            name: "Home",
            component: () => import("@/containers/DefaultContainer"),
            meta: { hideInBreadcrumb: true },
            children: [
                {
                    path: "dashboard",
                    name: "Dashboard",
                    component: () => import("@/views/Dashboard"),
                },
                {
                    path: "carousel",
                    name: "Pengaturan Carousel untuk Dashboard",
                    component: () => import("@/views/carousel/ListCarousel"),
                },
                {
                    path: "divisi",
                    name: "Pengaturan Gambar Divisi",
                    component: () => import("@/views/division/ListDivision"),
                },
                {
                    path: "tipe",
                    name: "Pengaturan Rekomendasi Tipe Barang",
                    component: () => import("@/views/type/ListType"),
                },
                {
                    path: "grosir-eceran",
                    name: "Pengaturan Harga Grosir / Eceran",
                    component: () => import("@/views/price/PriceAdjustment"),
                },
                {
                    path: "payment-gateways",
                    name: "Pengaturan Metode Pembayaran",
                    component: () =>
                        import("@/views/gateway/ListGatewayPayment"),
                },
                {
                    path: "shipment-gateways",
                    name: "Pengaturan Metode Pengiriman",
                    component: () =>
                        import("@/views/gateway/ListGatewayShipment"),
                },
                {
                    path: "order",
                    name: "Pengaturan Order",
                    component: () => import("@/views/order/ListApproveOrder"),
                },
                {
                    path: "items",
                    name: "Daftar Items",
                    component: () => import("@/views/items/ListItems"),
                },
                {
                    path: "users",
                    name: "Daftar Pembeli",
                    component: () => import("@/views/users/ListUsers"),
                },
                {
                    path: "admin",
                    name: "Pengaturan Admin",
                    component: () => import("@/views/admin/ListAdmin"),
                },
                {
                    path: "address-system",
                    name: "Alamat & Sistem",
                    component: () => import("@/views/admin/AddressSystem"),
                },
                {
                    path: "sync-master",
                    name: "Sinkron Master Data",
                    component: () => import("@/views/master/SyncMasterData"),
                },
            ],
        },
        {
            path: "/login",
            name: "Login",
            component: () => import("@/views/Login"),
        },
    ];
}

export default new Router({
    mode: "history",
    linkActiveClass: "open active",
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes(),
});
